import React from "react"
import ReactDOM from "react-dom"
import { Provider } from "react-redux"
import { MemoryRouter as Router, Route } from "react-router-dom"
import BappUiProvider, { Platforms } from "@bappweb/provider"
import { store } from "./config/store"
import Main from "./pages"
import "@bappweb/provider/styles.css"
import "@bappweb/provider/sass/bapp-reboot.scss"
import "./assets/style.scss"

const App = () => {
  return (
    <Provider store={store}>
      <BappUiProvider theme="theme-default" platform={Platforms.Desktop}>
        <Router>
          <Route component={Main} />
        </Router>
      </BappUiProvider>
    </Provider>
  )
}

ReactDOM.render(<App />, document.getElementById("root"))
